var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSurveyData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 179,
    height: 162,
    viewBox: "0 0 179 162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_18_project_processing",
    "data-name": "18_project_processing",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4228",
    "data-name": "Group 4228",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4227",
    "data-name": "Group 4227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4225",
    "data-name": "Group 4225",
    transform: "translate(25.407 28.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2710",
    "data-name": "Path 2710",
    d: "M10,11c20.692,0,21.652,22.584,42.344,22.584S71.159,11,91.866,11,113.5,33.584,134.21,33.584",
    transform: "translate(-10 -11)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4224",
    "data-name": "Group 4224",
    transform: "translate(2.823 19.761)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1125",
    "data-name": "Line 1125",
    y1: 31,
    transform: "translate(16.771 11.01)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1126",
    "data-name": "Line 1126",
    y1: 19,
    transform: "translate(33.771 23.01)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1127",
    "data-name": "Line 1127",
    y1: 22,
    transform: "translate(50.771 20.01)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1128",
    "data-name": "Line 1128",
    y1: 36,
    transform: "translate(67.771 6.01)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1129",
    "data-name": "Line 1129",
    y1: 42,
    transform: "translate(84.771 0.01)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1130",
    "data-name": "Line 1130",
    y1: 28,
    transform: "translate(101.771 14.01)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2711",
    "data-name": "Path 2711",
    d: "M11,18V60.344H129.564V40.584",
    transform: "translate(-11 -18)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4226",
    "data-name": "Group 4226"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1893",
    "data-name": "Rectangle 1893",
    width: 175,
    height: 130,
    rx: 3,
    fill: "none",
    stroke: "#9e9e9e",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1131",
    "data-name": "Line 1131",
    x2: 6,
    y2: 28,
    transform: "translate(104 130)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1132",
    "data-name": "Line 1132",
    y1: 28,
    x2: 6,
    transform: "translate(65 130)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1133",
    "data-name": "Line 1133",
    x2: 73,
    transform: "translate(51 158)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1134",
    "data-name": "Line 1134",
    x2: 5,
    transform: "translate(85 119)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1894",
    "data-name": "Rectangle 1894",
    width: 153,
    height: 96,
    transform: "translate(11 11)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSurveyData);
export default __webpack_public_path__ + "static/media/NoSurveyData.b71466123ee754881521eec8a8a89b89.svg";
export { ForwardRef as ReactComponent };